import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NgSelectModule, NgOption  } from '@ng-select/ng-select';
import { HttpClientModule } from '@angular/common/http';
import { CommonServiceModule } from './common-service/common-service.module';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingRoutes } from './app-routing.module';
import { RegisterComponent } from './register/register.component';
import { RegisterComponent1 } from './register1/register1.component';
import { NgxTinymceModule } from 'ngx-tinymce';
import { DatePipe } from '@angular/common';
import { GlobalErrorHandler } from './common-service/globalError.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from "ngx-spinner";
import { ViewDetailsComponent } from 'src/app/ptr/view-details/view-details.component';
import { PtrPaymentReceiptComponent } from 'src/app/ptr/ptr-payment-receipt/ptr-payment-receipt.component';
import { DispatchProcessHistoryComponent } from './diarydak/outbound/dispatch-process-history/dispatch-process-history/dispatch-process-history.component';
import { ViewreceiptseComponent } from 'src/app/diarydak/outbound/ssa/viewreceiptse/viewreceiptse.component';
import { AcceptInspectionScehduleComponent } from './inspection/accept-inspection-scehdule/accept-inspection-scehdule.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { ProformaviewComponent } from './inspection/insadmin/proformaview/proformaview.component';
import { UidrRegistrationComponent } from './uidr-registration/uidr-registration.component';
//import { DocumentEditorModule } from '@txtextcontrol/tx-ng-document-editor';
import { PaymentComponent } from './payment/payment.component';
//import { TestComponentComponent } from './test-component/test-component.component';
//import { CountryMasterComponent } from 'src/app/diarydak/inbound/sectionincharge/country-master/country-master/country-master.component';
//import { sect } from 'src/app/anti-ragging/section-anti-ragging-list.component';
import { NgxIdleTimeoutModule } from 'ngx-idle-timeout';
import { NgxCaptchaModule } from 'ngx-captcha';
import { UidrCertificateComponent } from './uidr-certificate/uidr-certificate.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotUserComponent } from './forgot-user/forgot-user.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    RegisterComponent1,
    ProformaviewComponent,
    ViewDetailsComponent,
    PtrPaymentReceiptComponent,
    DispatchProcessHistoryComponent,
    ViewreceiptseComponent,
    UidrRegistrationComponent,
    //TestComponentComponent,
   // UgModuleComponent,
   //UgRegistrationComponent,
   //UgNewCollegeViewComponent,
    //UgRegistrationComponent
    AcceptInspectionScehduleComponent,
   ForgotPasswordComponent,
   PaymentComponent,
   UidrCertificateComponent,
   ForgotUserComponent,
   //CountryMasterComponent,
 
   
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    RouterModule,
    AppRoutingRoutes,
    CommonServiceModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    CKEditorModule,
    NgxTinymceModule.forRoot({
      baseURL: '//cdnjs.cloudflare.com/ajax/libs/tinymce/4.9.0/',
    }), 
    NgbModule,
    NgxSpinnerModule,
    NgSelectModule,
    NgxIdleTimeoutModule,
    NgxCaptchaModule
   // DocumentEditorModule,
  ],
  providers: [DatePipe],

  bootstrap: [AppComponent]
})
export class AppModule { }
